import { createSlice } from '@reduxjs/toolkit';

const loungeDetailsSlice = createSlice({
  name: 'loungeDetails',
  initialState: {},
  reducers: {
    setLoungeDetails(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setLoungeDetails } = loungeDetailsSlice.actions;

export default loungeDetailsSlice.reducer;
